module.exports = __webpack_public_path__ + "img/acky-bright-attack.6cc3935.jpg";